import * as yup from "yup";

export const ReasonForCancelSchema = yup.object({
  reason: yup.string().required(),
  other: yup.string(),
});

export type ReasonForCancelFormType = yup.InferType<typeof ReasonForCancelSchema>;
